<!-- ============================================================== -->
<!-- toggle and nav items -->
<!-- ============================================================== -->
<ul class="navbar-nav float-left mr-auto">
    <!-- <li class="nav-item d-none d-md-block">
        <a (click)="toggleSidebar.emit()" class="nav-link sidebartoggler waves-effect waves-light"
            href="javascript:void(0)">
            <i class="icon-arrow-left-circle font-18"></i>
        </a>
    </li> -->
    <div class="" *ngIf="!size.small" style="max-width: 550px; margin-top: 10px; margin-left: 20px;">
        <div class="row animate1 fadeIn" *ngIf="!topCalc?.year">
            <div class="col-md-12">
                <div class="bold c-danger fs16">For Support:</div>
                <div class="bold c-white fs16">   
                    1300 768 284 | enquiry&#64;taxrefundonspot.com.au
                </div>
            </div>
        </div>
        <div class="row animate1 fadeIn" *ngIf="topCalc?.year > 2000" (click)="openCalcDialog(topCalc)">
            <div class="col-md-8  text-right" style="border-right: 1px solid #999;">
                <div class="row">
                    <div class="col-md-12 c-white fs16" style="padding-right: 15px; margin-top: -5px; margin-bottom: 8px;">Refund estimate for year <strong class="c-yellow">{{topCalc.year}}</strong></div>
                    <div class="col-md-12 c-white fs10 wordwrap" style="margin-top:-10px; padding-right: 15px; line-height: 12px; text-align: justify">
                        <span class="c-danger bold">Note:</span> This is only estimate of your refund. Your Tax return will be reviewed by Accountant & we will try to maximize your tax refund.
                    </div>
                </div>
            </div>
            <div class="col-md-4 my-auto">
                <div class="col-md-12" style="margin-left: -15px !important;">
                    <span class="c-success fs26 bold" *ngIf="topCalc.ciFinalResult >= 0">{{topCalc.ciFinalResult | currency}}</span>
                    <span class="c-danger fs26 bold" *ngIf="topCalc.ciFinalResult < 0">{{-(topCalc.ciFinalResult) | currency}} Payable</span>
                </div>
            </div>
        </div>
    </div>
</ul>
<!-- ============================================================== -->
<!-- Right side toggle and nav items -->
<!-- ============================================================== -->
<ul class="navbar-nav float-right">
    <!-- <li class="nav-item d-md-block d-none">
        <form class="app-search">
            <input type="text" class="form-control" placeholder="Search for...">
            <a class="srh-btn">
                <i class="ti-search"></i>
            </a>
        </form>
    </li> -->
    <!-- For Desktop -->


    <!-- ============================================================== -->
    <!-- User profile and search -->
    <!-- ============================================================== -->
    <li class="nav-item" ngbDropdown placement="bottom-right">
        <a ngbDropdownToggle class="nav-link text-muted waves-effect waves-dark pro-pic" href="javascript:void(0)" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <span class="text-white text-lg font-bold"> <i class="fas fa-user-circle fs20 c-gray-a"></i> {{userFullname}} <i class="fas fa-chevron-down fs12 c-gray-8"></i></span>
        </a>
        <div class="dropdown-menu user-dd" ngbDropdownMenu>
            <div class="float-right mr-10">
                <span class="with-arrow">
                    <span class="bg-white"></span>
                </span>
            </div>


            <!-- <a class="dropdown-item" href="javascript:void(0)" (click)="profile()"> <i class="fas fa-user m-r-5 m-l-5"></i> My Profile</a> -->
            <a class="dropdown-item" href="javascript:void(0)" (click)="passwordReset()"> <i class="fas fa-sync-alt m-r-5 m-l-5"></i> Password Reset</a>

            <div class="dropdown-divider m0"></div>
            <a class="dropdown-item" href="javascript:void(0)" (click)="logout()">
                <i class="fa fa-power-off m-r-5 m-l-5"></i> Logout</a>

        </div>
    </li>
    <!-- ============================================================== -->
    <!-- User profile and search -->
    <!-- ============================================================== -->
</ul>